export const WEBSOCKETURL = 'wss://tv0khm2la8.execute-api.eu-west-1.amazonaws.com/prod/'
export const API = 'https://birdcam-view-api.cathcart.cx/camera/'
export const DEFAULTCAM = 'birdcamdf'
export const ANNOTATIONS = '/annotations.json'
export const CAMERAS = ['birdcamdf', 'nboxone']
export const DEFAULTAGG = 'duration';

